import { CrossReferenceMarker } from 'features/knowledgeDocumentViewer/components/viewer/shared/CrossReferenceMarker'
import { useCrossReferenceContext } from 'features/knowledgeDocumentViewer/contexts/CrossReferenceContext'
import styled from 'styled-components'

const Anchor = styled.div<{ $x: number; $y: number }>`
  position: absolute;
  left: ${({ $x }) => $x * 100}%;
  top: ${({ $y }) => $y * 100}%;
  width: calc(1.75rem / 3);
  height: calc(1.75rem / 3);
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 2;
`

export function CrossReferencePageMarker({ page }: { page: number }) {
  const marker = useCrossReferenceContext()?.marker
  if (!marker || marker.page !== page) return null
  return (
    <Anchor $x={marker.point[0]} $y={marker.point[1]}>
      <CrossReferenceMarker loading={marker.loading} />
    </Anchor>
  )
}
